<template>
  <ul class="nav" role="menubar" v-click-outside="{ handler: 'closeMenus' }">
    <li class="nav-item">
      <router-link :class="['nav-link', activePage === 'home' ? 'active' : '']" to="/" title="Zurück zur Startseite"
        @focus="closeMenus">
        <span class="material-icons-outlined" aria-hidden="true">cottage</span>
        Start
      </router-link>
    </li>

    <li class="nav-item">
      <button :class="['nav-link', 'no-btn', activePage === 'orte' ? 'active' : '']" type="button" aria-haspopup="true"
        :aria-expanded="openMenu === 'orte'" title="Einrichtungen Kategorien anzeigen"
        @click.stop="toggleMenu('orte', $event)" @keydown.esc="closeMenus">
        <span class="material-icons-outlined" aria-hidden="true">place</span>
        Einrichtungen
      </button>

      <div v-if="openMenu === 'orte'" :class="['mega-menu', 'mega-menu--compact']" :style="menuStyle('orte')"
        role="menu">
        <div v-for="category in mainCategories" :key="category.title" class="mega-col">
          <router-link class="mega-link" :to="category.to" role="menuitem" @click="closeMenus">
            <span :class="['dot', category.colorClass]" aria-hidden="true"></span>
            <span>{{ category.title }}</span>
            <span class="material-icons-outlined arrow" aria-hidden="true">
              navigate_next
            </span>
          </router-link>
        </div>
      </div>
    </li>

    <li class="nav-item">
      <button :class="['nav-link', 'no-btn', activePage === 'angebote' ? 'active' : '']" type="button"
        aria-haspopup="true" :aria-expanded="openMenu === 'angebote'" title="Angebote Kategorien anzeigen"
        @click.stop="toggleMenu('angebote', $event)" @keydown.esc="closeMenus">
        <span class="material-icons-outlined" aria-hidden="true">calendar_today</span>
        Angebote
      </button>

      <div v-if="openMenu === 'angebote'" class="mega-menu" :style="menuStyle('angebote')" role="menu">
        <div v-for="category in angebotCategories" :key="category.title" class="mega-col">
          <router-link class="mega-heading" :to="category.to" role="menuitem" @click="closeMenus">
            <img :src="category.icon" :alt="category.title" class="heading-icon" />
            <span :class="category.colorClass">{{ category.title }}</span>
          </router-link>
          <ul class="mega-list">
            <li v-for="item in category.items" :key="item.label">
              <router-link :to="categoryLink(item, category)" role="menuitem" @click="closeMenus">
                {{ item.label }}
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </li>

    <li class="nav-item">
      <button :class="['nav-link', 'no-btn', activePage === 'infos' ? 'active' : '']" type="button" aria-haspopup="true"
        :aria-expanded="openMenu === 'infos'" title="Info-Menü öffnen" @click.stop="toggleMenu('infos', $event)"
        @keydown.esc="closeMenus">
        <span class="material-icons-outlined" aria-hidden="true">info</span>
        Infos
      </button>

      <div v-if="openMenu === 'infos'" :class="['mega-menu', 'mega-menu--compact']" :style="menuStyle('infos')"
        role="menu">
        <div v-for="info in infoLinks" :key="info.title" class="mega-col">
          <router-link class="mega-link" :to="info.to" role="menuitem" @click="closeMenus">
            <img :src="info.icon" :alt="info.title" class="heading-icon" />
            <span>{{ info.title }}</span>
            <span class="material-icons-outlined arrow" aria-hidden="true">
              navigate_next
            </span>
          </router-link>
        </div>
      </div>
    </li>

    <li class="nav-item">
      <button :class="['nav-link', 'no-btn', activePage === 'mehr' ? 'active' : '']" type="button" aria-haspopup="true"
        :aria-expanded="openMenu === 'mehr'" title="Weitere Links anzeigen" @click.stop="toggleMenu('mehr', $event)"
        @keydown.esc="closeMenus">
        <span class="material-icons-outlined" aria-hidden="true">more_vert</span>
        Mehr
      </button>

      <div v-if="openMenu === 'mehr'" :class="['mega-menu', 'mega-menu--compact', 'mega-menu--more']"
        :style="menuStyle('mehr')" role="menu">
        <div class="mega-col">
          <component v-for="link in moreLinks" :key="link.id" :is="link.component" class="mega-link"
            :class="[{ 'mega-link--action': link.type === 'action', 'mega-link--separator': link.separator }]"
            v-bind="link.bind" @click="link.onClick ? link.onClick() : closeMenus">
            <template v-if="link.iconType === 'img'">
              <img :src="link.icon" :alt="link.title" class="heading-icon" />
            </template>
            <template v-else>
              <span class="material-icons-outlined heading-icon heading-icon--material" aria-hidden="true">{{ link.icon
              }}</span>
            </template>
            <span class="mega-link__title">{{ link.title }}</span>
            <span v-if="link.type !== 'action'" class="material-icons-outlined arrow" aria-hidden="true">
              navigate_next
            </span>
          </component>
        </div>
      </div>
    </li>
  </ul>
</template>

<script>
import clickOutside from '@/directives/click-outside';
import Resource from '@/api/resource';
import { showLoader, hideLoader, getStructuredFilters } from '@/utils/helpers';

export default {
  name: 'DesktopNav',
  directives: { clickOutside },
  data() {
    return {
      openMenu: null,
      ctOrte: null,
      ctAngebote: null,
      closeTimer: null,
      menuStyles: {},
      infoLinks: [
        {
          title: 'Ratgeber',
          to: { name: 'Guide' },
          icon: '/assets/icons/ratgeber.png',
        },
        {
          title: 'Merklisten',
          to: { name: 'Merkliste' },
          icon: '/assets/icons/merklisten.png',
        },
        {
          title: 'Kita- & Schulfinder',
          to: { name: 'BildungsFinder' },
          icon: '/assets/icons/Schulfinder.png',
        },
      ],
    }
  },
  created() {
    this.fetchContentTypes();
  },
  watch: {
    $route() {
      // Close menu when route changes (navigation occurs)
      this.closeMenus();
    }
  },
  computed: {
    activePage() {
      if (this.$route.path === '/') {
        return 'home';
      } else if (this.$route.path.includes('orte')) {
        return 'orte';
      } else if (this.$route.path.includes('angebote')) {
        return 'angebote';
      } else if (this.$route.path.includes('ratgeber') || this.$route.path.includes('merkliste')) {
        return 'infos';
      } else if (this.$route.path.includes('mehr')) {
        return 'mehr';
      }
      return '';
    },
    userLoggedIn() {
      if (this.$store.getters.getToken) {
        return true;
      }
      return false;
    },
    moreLinks() {
      const links = [
        {
          id: 'nutzungsbedingungen',
          component: 'router-link',
          iconType: 'material',
          icon: 'description',
          title: 'Nutzungsbedingungen',
          bind: { to: { name: 'Nutzungsbedingungen' }, role: 'menuitem', title: 'Zu den Nutzungsbedingungen' },
        },
        {
          id: 'datenschutz',
          component: 'router-link',
          iconType: 'material',
          icon: 'shield',
          title: 'Datenschutzerklärung',
          bind: { to: { name: 'Datenschutz' }, role: 'menuitem', title: 'Zu der Datenschutzerklärung' },
        },
        {
          id: 'dgs',
          component: 'router-link',
          iconType: 'img',
          icon: '/assets/dgs_symbol_black.png',
          title: 'Gebärdensprache',
          bind: { to: '/system/1811920', role: 'menuitem', title: 'Zu der Gebärdensprache in der Wolfsburger Lupe' },
        },
        {
          id: 'barrierefrei',
          component: 'router-link',
          iconType: 'material',
          icon: 'accessibility_new',
          title: 'Barrierefreiheitserklärung',
          bind: { to: '/barrierefrei', role: 'menuitem', title: 'Zu der Barrierefreiheitserklärung' },
        },
        {
          id: 'impressum',
          component: 'router-link',
          iconType: 'material',
          icon: 'person',
          title: 'Impressum',
          bind: { to: { name: 'Impressum' }, role: 'menuitem', title: 'Zu dem Impressum' },
        },
      ];

      if (this.userLoggedIn && !this.$hideUserAccountRelatedFunctions) {
        links.push({
          id: 'profile',
          component: 'router-link',
          iconType: 'material',
          icon: 'person',
          title: 'Mein Profil',
          bind: { to: { name: 'Profile' }, role: 'menuitem', title: 'Mein Profil' },
        });
        links.push({
          id: 'logout',
          component: 'button',
          type: 'action',
          iconType: 'material',
          icon: 'lock',
          title: 'Abmelden',
          onClick: this.logOut,
          bind: { type: 'button' },
        });
      } else if (!this.$hideUserAccountRelatedFunctions) {
        links.push({
          id: 'login',
          component: 'router-link',
          iconType: 'material',
          icon: 'person',
          title: 'Login',
          bind: { to: { name: 'Login' }, role: 'menuitem', title: 'Login' },
        });
      }

      links.push({
        id: 'anbietende',
        component: 'a',
        iconType: 'material',
        icon: 'open_in_new',
        title: 'Login für Anbietende',
        bind: {
          href: this.$loginForProvidersUrl,
          target: '_blank',
          rel: 'noopener noreferrer',
          role: 'menuitem',
        },
      });

      return links;
    },
    mainCategories() {
      const palette = ['dot--magenta', 'dot--yellow', 'dot--teal', 'dot--orange'];
      const filters = getStructuredFilters(this.ctOrte);
      if (!filters || !filters.length || !filters[0].options) return [];
      const fieldTypeId = filters[0].field_type_id;

      const categoryDotStyles = {
        'Beratung & Hilfe': 'dot--magenta',
        'Beratung und Hilfe': 'dot--magenta',
        Freizeit: 'dot--yellow',
        'Aus- & Weiterbildung': 'dot--teal',
        'Ausbildung & Weiterbildung': 'dot--teal',
        'Kita- & Schulfinder': 'dot--orange',
      };

      return filters[0].options.map((opt, idx) => {
        const filterValue = opt.label || opt.value;
        const filterArray = [[fieldTypeId, [filterValue]]];
        const filtersParam = encodeURIComponent(JSON.stringify(filterArray));
        const colorClass = categoryDotStyles[filterValue] || palette[idx % palette.length];

        return {
          title: filterValue,
          to: `/orte?filters=${filtersParam}`,
          colorClass,
        };
      });
    },
    angebotCategories() {
      const palette = ['accent--magenta', 'accent--yellow', 'accent--teal', 'accent--orange'];
      const icons = [
        '/assets/icons/beruf.png',
        '/assets/icons/hilfe.png',
        '/assets/icons/freizeit.png',
        '/assets/icons/kita.png',
      ];
      const categoryStyles = {
        'Beratung & Hilfe': {
          colorClass: 'accent--magenta',
          icon: '/assets/icons/hilfe.png',
        },
        'Beratung und Hilfe': {
          colorClass: 'accent--magenta',
          icon: '/assets/icons/hilfe.png',
        },
        Freizeit: {
          colorClass: 'accent--yellow',
          icon: '/assets/icons/freizeit.png',
        },
        'Aus- & Weiterbildung': {
          colorClass: 'accent--teal',
          icon: '/assets/icons/beruf.png',
        },
        'Ausbildung & Weiterbildung': {
          colorClass: 'accent--teal',
          icon: '/assets/icons/beruf.png',
        },
        'Kita- & Schulfinder': {
          colorClass: 'accent--orange',
          icon: '/assets/icons/kita.png',
        },
      };

      const filters = getStructuredFilters(this.ctAngebote);
      if (!filters || !filters.length || !filters[0].options) return [];
      const parentFieldTypeId = filters[0].field_type_id;

      return filters[0].options.map((opt, idx) => {
        const parentCategoryName = opt.label || opt.value;
        const parentFilterArray = [[parentFieldTypeId, [parentCategoryName]]];
        const parentFiltersParam = encodeURIComponent(JSON.stringify(parentFilterArray));
        const styles = categoryStyles[parentCategoryName] || {
          colorClass: palette[idx % palette.length],
          icon: icons[idx % icons.length],
        };

        return {
          title: parentCategoryName,
          to: `/angebote?filters=${parentFiltersParam}`,
          colorClass: styles.colorClass,
          icon: styles.icon,
          parentFieldTypeId: parentFieldTypeId,
          parentCategoryName: parentCategoryName,
          subFieldTypeId: opt.field_type_id,
          items: (opt.options || []).map((sub) => ({
            label: sub.label || sub.value,
            fieldTypeId: opt.field_type_id,
          })),
        };
      });
    },
  },
  methods: {
    showLoader,
    hideLoader,
    logOut() {
      this.loader = this.showLoader(this.loader);
      this.$store.dispatch('logout');

      this.$notify({
        duration: 3500,
        title: 'Erfolgreich abgemeldet!',
        text: 'Sie haben sich von der Wolfsburger Lupe abgemeldet.'
      });

      this.loader = this.hideLoader(this.loader);
      this.$router.push({ name: 'Home' });
    },
    goHome() {
      if (this.route == "/") {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
      else {
        this.$router.push('/')
      }
    },
    toggleMenu(menu, evt) {
      // If clicking the same menu that's already open, close it
      if (this.openMenu === menu) {
        this.closeMenus();
        return;
      }
      // Otherwise, open the new menu
      if (evt) {
        this.computePlacement(menu, evt);
      }
      this.openMenu = menu;
    },
    closeMenus() {
      this.openMenu = null;
      this.clearClose();
    },
    categoryLink(item, category) {
      // Build filter array with both parent and sub-filter
      const filterArray = [
        [category.parentFieldTypeId, [category.parentCategoryName]],
        [item.fieldTypeId, [item.label]]
      ];
      const filtersParam = encodeURIComponent(JSON.stringify(filterArray));
      return `/angebote?filters=${filtersParam}`;
    },
    fetchContentTypes() {
      const resource = new Resource('contenttypes');
      resource.get(1).then((res) => {
        this.ctOrte = res.data;
      }).catch(() => {
        this.ctOrte = null;
      });
      resource.get(2).then((res) => {
        this.ctAngebote = res.data;
      }).catch(() => {
        this.ctAngebote = null;
      });
    },
    onHover(menu, evt) {
      this.computePlacement(menu, evt);
      this.openMenu = menu;
      this.clearClose();
    },
    menuPlacementClass(menu) {
      const pos = this.menuPlacement[menu] || 'right';
      return `mega-menu--${pos}`;
    },
    computePlacement(menu, evt) {
      const target = evt && evt.currentTarget;
      const desired = menu === 'angebote' ? 660 : 320;
      if (!target) {
        this.menuPlacement[menu] = menu === 'angebote' ? 'center' : 'right';
        return;
      }
      const rect = target.getBoundingClientRect();
      const spaceRight = window.innerWidth - rect.right;
      const spaceLeft = rect.left;

      if (menu === 'angebote' && spaceLeft > desired && spaceRight > desired) {
        this.menuPlacement[menu] = 'center';
        return;
      }

      if (spaceRight >= desired) {
        this.menuPlacement[menu] = 'right';
      } else if (spaceLeft >= desired) {
        this.menuPlacement[menu] = 'left';
      } else {
        this.menuPlacement[menu] = 'center';
      }
    },
    scheduleClose() {
      this.clearClose();
      this.closeTimer = setTimeout(() => {
        this.openMenu = null;
      }, 120);
    },
    clearClose() {
      if (this.closeTimer) {
        clearTimeout(this.closeTimer);
        this.closeTimer = null;
      }
    },
    onHover(menu, evt) {
      this.computePlacement(menu, evt);
      this.openMenu = menu;
      this.clearClose();
    },
    menuStyle(menu) {
      return this.menuStyles[menu] || {};
    },
    computePlacement(menu, evt) {
      const widthMap = { angebote: 720, default: 360 };
      const desired = widthMap[menu] || widthMap.default;
      const button = evt && evt.currentTarget;
      if (!button) {
        this.menuStyles[menu] = {};
        return;
      }
      const rect = button.getBoundingClientRect();
      const maxWidth = Math.min(desired, window.innerWidth - 24);
      let left = rect.left + (rect.width / 2) - (maxWidth / 2);
      left = Math.max(12, Math.min(left, window.innerWidth - maxWidth - 12));

      const top = rect.bottom + 8;

      this.$set(this.menuStyles, menu, {
        width: `${maxWidth}px`,
        left: `${left}px`,
        top: `${top}px`,
      });
    }
  }
}

</script>

<style lang="scss" scoped>
@import '@/scss/_variables.scss';

.nav {
  align-items: center;

  &-item {
    position: relative;
  }

  &-link {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    color: #5f6470;
    font-size: 15px;
    padding: 12px 16px;
    border-radius: 14px;
    transition: color 0.2s ease, background-color 0.2s ease, box-shadow 0.2s ease;

    span.material-icons-outlined {
      color: #9aa0ab;
      font-size: 20px;
    }

    &:hover,
    &:focus-visible {
      color: $primary;
      background: rgba($primary, 0.08);
      box-shadow: 0 8px 18px rgba(0, 0, 0, 0.06);

      span.material-icons-outlined {
        color: $primary;
      }
    }

    &.active {
      color: $primary;
      background: rgba($primary, 0.12);
      box-shadow: inset 0 0 0 1px rgba($primary, 0.25), 0 10px 20px rgba(0, 0, 0, 0.08);

      span.material-icons-outlined {
        color: $primary;
      }
    }
  }
}

.mega-menu {
  position: fixed;
  display: grid;
  grid-template-columns: repeat(3, minmax(200px, 1fr));
  gap: 18px;
  padding: 20px 22px;
  background: $white-color;
  box-shadow: 0 16px 36px rgba(0, 0, 0, 0.12);
  border-radius: 14px;
  box-sizing: border-box;
  z-index: 20;
  overflow: hidden;

  &--compact {
    grid-template-columns: repeat(1, minmax(200px, 1fr));
    min-width: 300px;
    max-width: 420px;
    width: calc(100vw - 24px);
  }

  @media (max-width: 1200px) {
    grid-template-columns: repeat(2, minmax(200px, 1fr));
    min-width: 480px;
  }

  @media (max-width: 820px) {
    grid-template-columns: repeat(1, minmax(220px, 1fr));
    min-width: 0;
  }

  .mega-col {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .mega-heading {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    font-weight: 700;
    color: $text-color;
    text-decoration: none;

    &:hover,
    &:focus-visible {
      text-decoration: none;
      color: $primary;
    }
  }

  .heading-icon {
    width: 28px;
    height: 28px;
    object-fit: contain;
  }

  .mega-list {
    list-style: none;
    padding: 0;
    margin: 0;

    li+li {
      margin-top: 6px;
    }

    a {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      color: $text-color;
      font-size: 14px;
      text-decoration: none;
      padding: 4px 0;

      &:hover,
      &:focus-visible {
        color: $primary;
      }
    }
  }

  .mega-link {
    display: inline-flex;
    align-items: center;
    width: 100%;
    gap: 10px;
    padding: 10px 12px;
    border-radius: 10px;
    color: $text-color;
    background: rgba($primary, 0.03);
    text-decoration: none;
    transition: background 0.2s ease, box-shadow 0.2s ease;

    .arrow {
      margin-left: auto;
      font-size: 20px;
      color: $text-light;
    }

    &:hover,
    &:focus-visible {
      background: rgba($primary, 0.08);
      box-shadow: inset 0 0 0 1px rgba($primary, 0.12);
      color: $primary;

      .arrow {
        color: $primary;
      }
    }
  }
}

.custom-dropdown {
  display: block;
  position: absolute;
  width: 290px;
  background: #FFFFFF;
  top: 28px;
  right: 0;
  box-shadow: 0px 2px 8px 0px #00000040;
  padding: 0 15px;
}

.logout-btn {
  margin-top: 15px;
  margin-bottom: 15px;
  width: 100%;
}

body[dir="rtl"] {
  .custom-dropdown {
    right: -220px;
  }
}

.mega-menu--more .mega-col {
  gap: 10px;
}

.mega-menu--more .mega-link {
  font-size: 14px;
  padding: 10px 12px;
  border-radius: 10px;
}

.mega-menu--more .mega-link__title {
  font-weight: 700;
  color: $text-color;
}

.mega-menu--more .heading-icon,
.mega-menu--more .heading-icon--material {
  width: 24px;
  height: 24px;
  font-size: 22px;
  color: $text-light;
}

.mega-menu--more .mega-link--separator {
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  padding-bottom: 12px;
  margin-bottom: 6px;
}

.mega-menu--more .mega-link--action {
  justify-content: flex-start;
  gap: 10px;
  font-weight: 700;
}

.dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;

  &--magenta {
    background: #cb0b5f;
  }

  &--yellow {
    background: #f3c200;
  }

  &--teal {
    background: #007a83;
  }

  &--orange {
    background: #f08a28;
  }
}

.accent--magenta {
  color: #cb0b5f;
}

.accent--yellow {
  color: #e2aa00;
}

.accent--teal {
  color: #007a83;
}

.accent--orange {
  color: #f08a28;
}
</style>
